export default (vue, statePropObj, propName) => {
	const val = statePropObj[propName];

	vue.delete(statePropObj, propName);
	vue.set(statePropObj, propName, val);
};